import Vue from 'vue';

import { config, library, dom } from '@fortawesome/fontawesome-svg-core';
import {
    faSearch,
    faArrowLeft,
    faArrowRight,
    faUser,
    faAt,
    faEnvelope,
    faPhone,
    faChevronRight,
    faChevronDown,
    faChevronUp,
    faCloudUploadAlt,
    faTrashAlt,
    faCheck,
    faTimes,
    faFileAlt,
    faFileImage,
    faFileVideo,
    faFileArchive,
    faFileWord,
    faFilePowerpoint,
    faFileExcel,
    faFileCsv,
    faFileAudio,
    faAngleDoubleRight,
    faAngleDoubleDown,
    faCaretUp,
    faCaretDown,
    faThList,
    faCalendarAlt,
    faCalendarWeek,
    faCalendarDay,
    faMapMarker,
    faAngleDown
} from '@fortawesome/free-solid-svg-icons';

// import { far } from '@fortawesome/free-regular-svg-icons'

import { faFacebookF, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';

config.searchPseudoElements = true;
config.autoReplaceSvg = 'nest';

library.add(faSearch);
library.add(faArrowLeft);
library.add(faArrowRight);
library.add(faUser);
library.add(faAt);
library.add(faEnvelope);
library.add(faPhone);
library.add(faChevronRight);
library.add(faChevronDown);
library.add(faChevronUp);
library.add(faCloudUploadAlt);
library.add(faTrashAlt);
library.add(faCheck);
library.add(faTimes);
library.add(faFileAlt);
library.add(faFileImage);
library.add(faFileVideo);
library.add(faFileArchive);
library.add(faFileWord);
library.add(faFilePowerpoint);
library.add(faFileExcel);
library.add(faFileCsv);
library.add(faFileAudio);
library.add(faAngleDoubleRight);
library.add(faAngleDoubleDown);
library.add(faAngleDown);
library.add(faCaretUp);
library.add(faCaretDown);
library.add(faThList);
library.add(faCalendarAlt);
library.add(faCalendarWeek);
library.add(faCalendarDay);
library.add(faMapMarker);

library.add(faFacebookF);
library.add(faTwitter);
library.add(faYoutube);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
Vue.component('font-awesome-icon', FontAwesomeIcon);

dom.watch();
